import Auth from "./auth/reducer";

export default { Auth };
